<script setup lang="ts">
  import type { TypographyProps } from '../Typography/Typography.vue'
  declare global {
    interface Window {
      googlefc: {
        callbackQueue: Array<(() => void) | { CONSENT_API_READY: () => void }>
        showRevocationMessage: () => void
      }
    }
  }

  const { t } = useI18n()

  const props = defineProps<TypographyProps>()
  const hasLoadedGoogleAPI = ref(false)

  onMounted(() => {
    window.googlefc = window.googlefc || {}
    window.googlefc.callbackQueue = window.googlefc.callbackQueue || []
    window.googlefc.callbackQueue.push({
      CONSENT_API_READY: () => {
        hasLoadedGoogleAPI.value = true
      },
    })
  })

  const className = computed(() =>
    hasLoadedGoogleAPI.value
      ? 'cursor-pointer hover:underline visited:no-underline '
      : 'opacity-50 pointer-events-none'
  )

  const linkTagProps = computed(() => {
    if (hasLoadedGoogleAPI.value) {
      return {
        href: 'javascript:googlefc.callbackQueue.push(googlefc.showRevocationMessage)',
      }
    } else {
      return { 'aria-disabled': true }
    }
  })
</script>
<template>
  <a id="revocation-link" v-bind="linkTagProps">
    <Typography v-bind="props" :class="className">
      {{ t('Privacy and Cookie Settings') }}
    </Typography>
  </a>
</template>
